import { ExpertAdvice } from "@/common/api.service";
import { FETCH_LIST_QUESTION_CONFERENCE } from "./actions.type";
import {
  FETCH_LIST_QUESTION_CONFERENCE_END,
  FETCH_LIST_QUESTION_CONFERENCE_START
} from "@/store/mutations.type";

const state = {
  listQuestionConference: {},
  isListQuestionConference: false
};

const getters = {
  listQuestionConference() {
    return state.listQuestionConference;
  },
  isListQuestionConference() {
    return state.isListQuestionConference;
  }
};

const actions = {
  async [FETCH_LIST_QUESTION_CONFERENCE]({ commit }, params) {
    commit(FETCH_LIST_QUESTION_CONFERENCE_START);
    return ExpertAdvice.getListQuestionAndDocByVote(params)
      .then(({ data }) => {
        commit(FETCH_LIST_QUESTION_CONFERENCE_END, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  }
};

const mutations = {
  [FETCH_LIST_QUESTION_CONFERENCE_START](state) {
    state.isListQuestionConference = true;
  },
  [FETCH_LIST_QUESTION_CONFERENCE_END](state, list) {
    state.listQuestionConference = list;
    state.isListQuestionConference = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
